export default () => ({
  editTextContainer: {
    marginTop: '20px',
  },
  editTextViewContainer: {
    alignSelf: 'center',
  },
  editTextEditContainer: {
    marginBottom: '50px',
  },
  editTextActionStartContainer: {
    textAlign: 'center',
    alignSelf: 'flex-start',
  },
  editTextActionEndContainer: {
    textAlign: 'center',
    alignSelf: 'flex-end',
  },
  editTextButton: {
    color : '#f39200',
	  border : '1px solid rgba(243, 146, 0, 0.5)',
    margin: 10,
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },   
  },
});  